import script from "./ScreenDisplay.vue?vue&type=script&setup=true&lang=js"
export * from "./ScreenDisplay.vue?vue&type=script&setup=true&lang=js"

import "./ScreenDisplay.vue?vue&type=style&index=0&id=334d2bd0&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-334d2bd0"]])

export default __exports__